// extracted by mini-css-extract-plugin
export var active = "_sb-1";
export var circle = "_sb-0";
export var completed = "_sb-2";
export var connector = "_sb-4";
export var connectorCompleted = "_sb-7";
export var connectorSpacer = "_sb-5";
export var iconStrokeOverride = "_sb-8";
export var labelContainer = "_sb-6";
export var pending = "_sb-3";